import { useState, useEffect } from "react";
import type { ThemaCode } from "reedy-data/api";

export const useNavigationState = (activeTab: string, query: string) => {
  const [navigationStack, setNavigationStack] = useState<ThemaCode[]>([]);

  // Reset navigation when search query changes
  useEffect(() => {
    if (query) {
      // clears tree navigation after a submitted search query commits; the stack drives the data query, so resetting during render would alter request timing
      setNavigationStack([]);
    }
  }, [query]);

  // Reset navigation when switching tabs
  useEffect(() => {
    // clears the drill-down stack when the active tab changes; the stack feeds the data query, so resetting it during render would alter request timing
    setNavigationStack([]);
  }, [activeTab]);

  const handleDrillDown = (code: ThemaCode) => {
    setNavigationStack((prev) => [...prev, code]);
  };

  const handleNavigateToLevel = (targetItem: ThemaCode) => {
    const targetIndex = navigationStack.findIndex(
      (item) => item.id === targetItem.id,
    );
    if (targetIndex >= 0) {
      setNavigationStack((prev) => prev.slice(0, targetIndex));
    }
  };

  const currentParent =
    navigationStack.length > 0
      ? navigationStack[navigationStack.length - 1]
      : null;

  return {
    navigationStack,
    currentParent,
    handleDrillDown,
    handleNavigateToLevel,
    resetNavigation: () => setNavigationStack([]),
  };
};
